if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        Vi søger efter din forsendelse...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Søger…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "DK"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                For mange forsøg
            </div>

            <div class="ee-error-message">
                Du har søgt for mange gange i træk. Vent et minut, og prøv igen.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Ordren er blevet annulleret
            </div>

            <div class="ee-error-message">
                Denne ordre er blevet annulleret og vil ikke blive behandlet.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    Vi forbereder din ordre
                </div>

<div class="ee-info-message">


 <br>

    Din ordre er modtaget og er ved at blive behandlet.

    <br><br>

    Der er endnu ikke tildelt et sporingsnummer. Når forsendelsen er afsendt, vil sporingsoplysningerne være tilgængelige på denne side og via e-mail.

    <br><br>

    Hvis du har yderligere spørgsmål om din ordre, bedes du kontakte vores kundeservice.

    <br>

                    <a href="https://euroelectronics.dk/pages/kontakt" class="ee-contact-link">
                        Kontakt os
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Ordren blev ikke fundet
                </div>

                <div class="ee-error-message">
                    Vi kunne ikke finde en ordre, der matcher det angivne ordrenummer og e-mailadresse. Kontrollér, at oplysningerne er indtastet korrekt, og prøv igen.
                    <br><br>

                    Hvis du har brug for hjælp, bedes du kontakte vores kundeservice.
                    <br>

                    <a href="https://euroelectronics.dk/pages/kontakt" class="ee-contact-link">
                        Gå til kontaktformularen
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Forsendelse fundet
                        </div>
<div class="ee-result-description">
                            Nedenfor finder du oplysninger om din forsendelse. Klik på knappen nedenfor for at gå direkte til sporing hos transportøren.
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Ordrenummer
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Sporingsnummer
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Spor forsendelsen
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Bestilte produkter (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Der opstod en fejl
                        </div>

                        <p>
                            Vi kunne ikke oprette forbindelse til sporingssystemet. Prøv igen om et øjeblik.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}
